import React, { useEffect } from 'react';
import anime from 'animejs';

const MarineTrafficEmbed = ({ latitude, longitude, zoom = 9, mtembedcode }) => {
  // MarineTraffic artık tamamen HTTPS üzerinden hizmet vermektedir.
  // Doğrudan https sabitlemek mixed-content ve SSR (Server-Side Rendering) hatalarını önler.
  const mapUrl = mtembedcode
    ? `https://www.marinetraffic.com/en/ais/customembed/zoom:${zoom}/centery:${latitude}/centerx:${longitude}/mmsi:0/mtembedcode:${mtembedcode}`
    : `https://www.marinetraffic.com/en/ais/embed/zoom:${zoom}/centery:${latitude}/centerx:${longitude}/maptype:4/shownames:false/mmsi:0/shipid:0/fleet:/fleet_id:/vtypes:/showmenu:/remember:false`;

  return (
    <div className="w-full h-[350px] md:h-[500px] rounded-[2rem] overflow-hidden shadow-2xl border border-white/10 bg-[#0f172a]/40 backdrop-blur-md p-2 relative group-hover:scale-[1.01] transition-transform duration-700">
      <iframe
        src={mapUrl}
        width="100%"
        height="100%"
        frameBorder="0"
        scrolling="no"
        title="MarineTraffic"
        className="rounded-2xl opacity-0 animate-[fadeIn_1.5s_ease-in_forwards] relative z-10"
        // --- HATALARI GİDEREN ÖNEMLİ NİTELİKLER ---
        allow="fullscreen"
        allowFullScreen
      />
      <div className="absolute inset-0 -z-10 bg-[#1e293b] animate-pulse" />
    </div>
  );
};

const MAPS = [
  {
    label: 'Dardanelles Strait',
    sector: 'Sector 01',
    latitude: 40.0,
    longitude: 26.4,
    zoom: 7,
  },
  {
    label: 'Bosphorus Strait',
    sector: 'Sector 02',
    latitude: 41.05,
    longitude: 29.02,
    zoom: 7,
  },
];

const MarineTrafficMaps = ({ mtembedcode }) => {
  useEffect(() => {
    anime({
      targets: '.map-reveal',
      opacity: [0, 1],
      translateY: [40, 0],
      delay: anime.stagger(250),
      duration: 1500,
      easing: 'easeOutExpo',
    });
  }, []);

  return (
    <section className="w-full bg-[#0f172a] py-16 md:py-24 px-6 overflow-hidden font-sans relative">
      <div
        className="absolute inset-0 opacity-[0.06] pointer-events-none z-0"
        style={{
          backgroundImage: `
            linear-gradient(to right, #fcfcf9 1px, transparent 1px),
            linear-gradient(to bottom, #fcfcf9 1px, transparent 1px)
          `,
          backgroundSize: '50px 50px',
        }}
      />

      <div className="max-w-7xl mx-auto text-center mb-16 map-reveal opacity-0 relative z-10">
        <h2 className="text-3xl md:text-5xl font-black text-white uppercase italic tracking-tighter leading-none mb-6">
          Marine <span className="text-[#c4a47c]">Traffic</span>
        </h2>
        <div className="h-1.5 w-20 bg-[#c4a47c] mx-auto rounded-full" />
      </div>

      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-16 relative z-10">
        {MAPS.map((map) => (
          <div key={map.sector} className="map-reveal opacity-0 group">
            <div className="flex items-center justify-between mb-5 px-2">
              <div className="flex items-center space-x-3">
                <div className="w-2 h-2 rounded-full bg-[#c4a47c] animate-ping" />
                <h4 className="text-white font-black uppercase tracking-widest text-xs italic">
                  {map.label}
                </h4>
              </div>
              <span className="text-[9px] font-bold text-slate-400 uppercase tracking-widest">
                {map.sector}
              </span>
            </div>
            <MarineTrafficEmbed
              latitude={map.latitude}
              longitude={map.longitude}
              zoom={map.zoom}
              mtembedcode={mtembedcode}
            />
          </div>
        ))}
      </div>
    </section>
  );
};

export default MarineTrafficMaps;